'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

const StickyContactBar = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const contactInfo = {
    phone: '+966 55 2258277',
    email: 'info@centronics.com.sa',
    whatsapp: '+966 55 2258277'
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-brand-primary to-brand-secondary shadow-elevated transition-transform duration-300 ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="container mx-auto px-4 py-3">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
          {/* WhatsApp */}
          <a
            href={`https://wa.me/${contactInfo?.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 group w-full sm:w-auto justify-center"
          >
            <Icon name="ChatBubbleLeftRightIcon" size={20} className="text-white" />
            <span className="font-cta font-semibold text-sm text-white group-hover:scale-105 transition-transform">
              WhatsApp: {contactInfo?.whatsapp}
            </span>
          </a>

          {/* Phone */}
          <a
            href={`tel:${contactInfo?.phone}`}
            className="flex items-center space-x-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 group w-full sm:w-auto justify-center"
          >
            <Icon name="PhoneIcon" size={20} className="text-white" />
            <span className="font-cta font-semibold text-sm text-white group-hover:scale-105 transition-transform">
              {contactInfo?.phone}
            </span>
          </a>

          {/* Email */}
          <a
            href={`mailto:${contactInfo?.email}`}
            className="flex items-center space-x-2 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-200 group w-full sm:w-auto justify-center"
          >
            <Icon name="EnvelopeIcon" size={20} className="text-white" />
            <span className="font-cta font-semibold text-sm text-white group-hover:scale-105 transition-transform">
              {contactInfo?.email}
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default StickyContactBar;